import { 
  GET_STATE_OBJ_PROPERTIES 
} from '../constants/Constants';
  
  const initalState = {
    data: {}
  }
  
  export const getStateObjPropertiesReducer = (state = initalState, action = {}) => {
    switch (action.type) {
      case GET_STATE_OBJ_PROPERTIES:
        return {
            ...state,
            data: action.payload
        }
      default:
        return state;
    }
  }